module.exports = __webpack_public_path__ + "static/img/banner6.e980bfc3.png";